export default __webpack_public_path__ + "static/listicle-bg-fe8dec2efd6bf42f2ca280a3a1e3fcb7.jpg";